const BASE_URL = 'https://tropiphone.com';

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${BASE_URL}/#organization`,
    name: 'TropiPhone',
    url: BASE_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${BASE_URL}/logo.svg`,
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Spanish', 'English'],
    },
    // Actualizar con URLs reales de redes sociales
    sameAs: [],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${BASE_URL}/#website`,
    name: 'TropiPhone',
    url: BASE_URL,
    publisher: { '@id': `${BASE_URL}/#organization` },
  };
}

export function getServiceSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': `${BASE_URL}/#service`,
    name: 'Recargas de Móvil a Cuba',
    serviceType: 'Mobile Recharge',
    description:
      'Servicio de recarga de saldo móvil a Cuba de forma rápida, segura y confiable.',
    areaServed: {
      '@type': 'Country',
      name: 'Cuba',
    },
    provider: { '@id': `${BASE_URL}/#organization` },
    url: BASE_URL,
  };
}

// FAQs hardcodeadas para rich snippets — actualizar con las preguntas más representativas del producto
export function getFAQSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '¿Cómo puedo recargar saldo a Cuba?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Regístrate en TropiPhone, elige el operador y el monto de recarga, introduce el número de teléfono cubano y realiza el pago de forma segura. La recarga llega en minutos.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Cuánto tiempo tarda en llegar la recarga?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Las recargas se procesan de forma inmediata. En la mayoría de los casos el saldo llega en menos de 5 minutos.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Qué métodos de pago aceptan?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Aceptamos tarjetas de crédito y débito internacionales (Visa, Mastercard) de forma segura a través de nuestra plataforma de pago.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Es seguro realizar recargas con TropiPhone?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Sí. TropiPhone utiliza cifrado SSL y procesadores de pago certificados para garantizar la seguridad de cada transacción.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Puedo recargar a cualquier operador cubano?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Sí, ofrecemos recargas para los principales operadores de telefonía móvil en Cuba.',
        },
      },
    ],
  };
}
